module.exports = __webpack_public_path__ + "img/full0-min.bccba371.png";